import { render, staticRenderFns } from "./DrawerDialogRoot.vue?vue&type=template&id=71615ad4&"
var script = {}
import style0 from "./DrawerDialogRoot.vue?vue&type=style&index=0&id=71615ad4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports